/**
 * Requires
 */

import $ from 'jquery'
import backgroundColors from './constants/color-backgrounds'
import backgroundColorValues from './constants/header-background-color'

/**
 * Initialisation
 */

export function initialise() {
  const instances = []
  $('[data-carousel]').each((i, container) => {
    const instance = createSwiper(container)
    instances.push(instance)
  })
  return instances
}

function loadSwiper() {
  return import(/* webpackChunkName: "Swiper" */ 'swiper/swiper-bundle.js').then(m => m.default)
}

export function getHexColor(color) {
  return backgroundColorValues[color]?.color
}

function updateSwiperTheme(swiper) {
  const currentSlide = swiper.slides[swiper.activeIndex]
  if (!currentSlide) return
  const currentSlideBackground = $(currentSlide).data('swiper-background')
  if (!currentSlideBackground) return
  const hexColor = getHexColor(currentSlideBackground)
  removeBackgroundClass()
  $('[data-swiper-background-target]').addClass(`background-${currentSlideBackground ?? 'pink'}`)
  $('[data-hero-button]').addClass(`color-${currentSlideBackground ? currentSlideBackground + '-90' : 'pink-90'}`)
  $('[data-header]').css('color', hexColor || '#FF32AA')
  $('[data-menu-button]').css('color', hexColor || '#FF32AA')
  $('[data-main-menu').addClass(currentSlideBackground)
}

function removeBackgroundClass() {
  for (let i = 0; i < backgroundColors.length; i++) {
    const backgroundClass = backgroundColors[i]
    $('[data-swiper-background-target]').removeClass(`background-${backgroundClass}`)
    $('[data-hero-button]').removeClass(`color-${backgroundClass}-90`)
    $('[data-main-menu').removeClass(backgroundClass)
  }
}

function createSwiper(container) {
  return loadSwiper().then(Swiper => {
    const config = $(container).data('carousel')
    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      loop: config.loop === null ? false : config.loop,
      centeredSlides: config.centeredSlides === null ? false : config.centeredSlides,
      autoplay: config.autoplay === true ? true : false,
      navigation: {
        nextEl: `[data-button-next="${config.id}"]`,
        prevEl: `[data-button-prev="${config.id}"]`,
      },
      on: {
        init: function() {
          updateSwiperTheme(this)
        },
      },
      pagination: {
        el: `[data-pagination="${config.id}"]`,
        clickable: true,
        renderBullet: function(index, className) {
          return '<span class="swiper-pagination-bullet"></span>'
        },
      },
    })

    swiper.on('slideChange', function() {
      updateSwiperTheme(swiper)
    })
    return swiper
  })
}
